export default "__VITE_ASSET__BCzrK3Kk__"